export default __webpack_public_path__ + "acd0b75e56c46c42e3937fcfe57a71a8.png";